import { render } from "./Results.vue?vue&type=template&id=7dc7cd5e&scoped=true"
import script from "./Results.vue?vue&type=script&lang=js"
export * from "./Results.vue?vue&type=script&lang=js"

import "./Results.vue?vue&type=style&index=0&id=7dc7cd5e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7dc7cd5e"

export default script